import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { PurchaseOrderEntity } from './purchase-order.entity';

/**
 * Link table between PurchaseOrder and File. Mirrors the
 * `sourcing_request_file` / `order__file` patterns. Used by the RFQ
 * workflow to persist generated RFQ PDFs against the QUOTE PO so
 * the same artifact can be re-downloaded later for audit, and by
 * the regular PO flow for any PO-attached files (vendor confirmations,
 * etc.). See docs/claude/sourcing-requests/RFQ-DESIGN.md.
 */
@Index('purchase_order__file__fk__file__id_fk', ['fkFileId'], {})
@Index(
	'purchase_order__file__fk_purchase_order__id_fk',
	['fkPurchaseOrderId'],
	{},
)
@Entity('purchase_order__file')
export class PurchaseOrderFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column('int', { name: '_fk_purchase_order__id', unsigned: true })
	public fkPurchaseOrderId!: number;

	@ManyToOne(
		() => PurchaseOrderEntity,
		(purchaseOrder) => purchaseOrder.purchaseOrderFiles,
		{
			onDelete: 'CASCADE',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk_purchase_order__id', referencedColumnName: 'id' }])
	public fkPurchaseOrder!: PurchaseOrderEntity;

	@ManyToOne(() => FileEntity, (file) => file.purchaseOrderFiles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
